import React from "react";
// import your 5 images
import Artboard1 from "../../assets/Artboard1.webp";
import Artboard2 from "../../assets/Artboard2.webp";
import Artboard3 from "../../assets/Artboard3.webp";
import Artboard4 from "../../assets/Artboard4.webp";
import Artboard5 from "../../assets/Artboard5.webp";
import Artboard6 from "../../assets/Artboard6.webp";
import Artboard8 from "../../assets/Artboard8.webp";
import Artboard9 from "../../assets/Artboard9.webp";
import Artboard10 from "../../assets/Artboard10.webp";
import Artboard11 from "../../assets/Artboard11.webp";
import Artboard12 from "../../assets/Artboard12.webp";
import Artboard13 from "../../assets/Artboard13.webp";
import Artboard14 from "../../assets/Artboard14.webp";
import Artboard15 from "../../assets/Artboard15.webp";
import Artboard16 from "../../assets/Artboard16.webp";
import Artboard17 from "../../assets/Artboard17.webp";
import Artboard18 from "../../assets/Artboard18.webp";
import Artboard19 from "../../assets/Artboard19.webp";
import Artboard20 from "../../assets/Artboard20.webp";



export default function SixImageSections() {
  const images = [
  Artboard1, Artboard2, Artboard3, Artboard4, Artboard5,
  Artboard6, Artboard8, Artboard9, Artboard10, Artboard11,
  Artboard12, Artboard13, Artboard14, Artboard15, Artboard16,
  Artboard17, Artboard18, Artboard19, Artboard20,
];

  return (
    <>
      {/* Images Section */}
      <div className="flex flex-col gap-0 pt-16 pb-16">
        {images.map((image, index) => (
          <div key={index} className="relative w-full">
            {/* 🔹 Blurred Background */}
            <div
              className="absolute inset-0 bg-cover bg-center blur-2xl"
              style={{ backgroundImage: `url(${Artboard1})` }}
            ></div>

            {/* 🔹 Centered Sharp Container */}
            <div className="relative z-10 flex justify-center items-center py-0 px-4">
              <img
                src={image}
                alt={`Section ${index + 1}`}
                className="max-w-full h-auto"
              />
            </div>
          </div>
        ))}
      </div>

      {/* Logo Section */}
      <section
        style={{
          width: "100%",
          minHeight: "25svh",
          scrollSnapAlign: "start",
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "center",
          paddingBottom: "40px",
        }}
      >
        <img
          src="/logo.png"
          alt="Logo"
          style={{
            width: "80px",
            height: "auto",
            opacity: 0.9,
          }}
        />
      </section>
    </>
  );
}